import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.baseUrl = process.env.MIX_APP_WEB_ENDPOIN;

Vue.use(Vuex)

const state = {
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    varianAlert: '',
    messageAlert: '',
    userAuth: null,
    fixedToasts: 0,
    flashAlert: [],
    errorResponseComponent: ''
}

const mutations = {
    set(state, [variable, value]) {
        state[variable] = value
    },
    setAlertValues(state, alertData = {}) {
        state.variantAlert = alertData.variant;
        state.messageAlert = alertData.message;
    },
    setFlash(state, alert) {
        var alerts = state.flashAlert;
        alerts.push(alert);
        state.flashAlert = alerts;
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions: {
        getUser({ commit }) {
            return axios.get('/api/user')
                .then((res) => {
                    let user = res.data;
                    commit("set", ["userAuth", user]);
                })
                .catch((err) => {
                    commit("set", ["userAuth", null]);
                });
        },
        logout({ commit }) {
            commit("set", ["columnFilter", null]);
            commit("set", ["flashAlert", []]);
            commit("set", ["userAuth", null]);
            axios.post('/logout');
        }
    }
})
